import { useEffect, useState } from "react";
import { api } from "../lib/api";

const AVATARS = [
  "https://images.unsplash.com/photo-1502685104226-ee32379fefbe?w=120&q=80",
  "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=120&q=80",
  "https://images.unsplash.com/photo-1547425260-76bcadfb4f2c?w=120&q=80",
  "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&q=80",
  "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=120&q=80",
];

export default function NewsletterBlock({ extended = false }) {
  const [form, setForm] = useState({ nombre: "", email: "" });
  const [submitting, setSubmitting] = useState(false);
  const [count, setCount] = useState(320);
  const [toast, setToast] = useState(null);
  const [done, setDone] = useState(false);

  useEffect(() => {
    api.get("/newsletter/count").then((r) => setCount(r.data.count)).catch(() => {});
  }, []);

  const showToast = (msg, type = "ok") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 2800);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!form.nombre.trim() || !form.email.trim()) {
      showToast("Nombre y email son obligatorios", "error");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/newsletter", form);
      setDone(true);
      setForm({ nombre: "", email: "" });
      setCount((c) => c + 1);
      showToast("¡Te has suscrito! Revisa tu correo.");
    } catch (err) {
      const msg = err?.response?.data?.detail || "No pudimos suscribirte";
      showToast(msg, "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="newsletter" className="section" data-testid="newsletter-section">
      <div className="container">
        <div className="newsletter-grid reveal">
          <div>
            <div className="section-eyebrow" style={{ color: "#D9A6EB" }}>
              Berenice — Sin Filtro · Sin algoritmos
            </div>
            <h3>
              Escribo, <em>tú lo recibes</em>.
            </h3>
            <p>
              Solo un correo cuando publique algo que valga tu tiempo. Sin
              spam, sin filtros.
            </p>
            <ul className="perks">
              <li>Una carta cuidada, el primer domingo del mes</li>
              <li>Pequeños textos que no publico en el blog</li>
              <li>Respondo a todos los correos personalmente</li>
            </ul>
            <div className="avatars-row">
              <div className="avatars-stack">
                {AVATARS.map((a, i) => (
                  <img key={i} src={a} alt="" />
                ))}
              </div>
              <span className="subs-count">+{count} lectores</span>
            </div>
          </div>

          <form
            className="newsletter-form"
            onSubmit={submit}
            data-testid="newsletter-form"
          >
            {done && !extended ? (
              <div style={{ color: "#fff", padding: "16px 0" }}>
                <h4 style={{ color: "#fff", marginBottom: 8 }}>Listo.</h4>
                <p style={{ color: "rgba(247,245,240,0.7)" }}>
                  Te escribiré el primer domingo del mes. Gracias por estar.
                </p>
              </div>
            ) : (
              <>
                <input
                  type="text"
                  placeholder="Tu nombre"
                  value={form.nombre}
                  onChange={(e) => setForm({ ...form, nombre: e.target.value })}
                  data-testid="newsletter-nombre-input"
                />
                <input
                  type="email"
                  placeholder="tu@correo.com"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  data-testid="newsletter-email-input"
                />
                <button
                  type="submit"
                  className="btn"
                  disabled={submitting}
                  data-testid="newsletter-submit-btn"
                >
                  {submitting ? "Un momento…" : "Recibir la carta mensual →"}
                </button>
                <p className="newsletter-hint">
                  Tu email nunca se comparte. Dos clics para darte de baja.
                </p>
              </>
            )}
          </form>
        </div>
      </div>
      {toast && (
        <div className={`toast ${toast.type === "error" ? "error" : ""}`} data-testid="newsletter-toast">
          {toast.msg}
        </div>
      )}
    </section>
  );
}
